import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconAutomation from './nav-icon-automation.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconAutomation {...validProps} />;
}
SvgComponent.iconName = 'navIconAutomation';

export const NavIconAutomationIcon = svgIconWrapper(SvgComponent);
